// Holds the "current project" navigation context — the spine of ADR 010.
// Every scoped list reads `selectedProjectId` and refetches when it changes.
// Persisted to localStorage so the choice survives reloads.

import { defineStore } from "pinia";
import { ref } from "vue";

import type { ProjectInfo } from "@/api/client";

const STORAGE_KEY = "ecs.selectedProjectId";

export const useProjectStore = defineStore("project", () => {
  const selectedProjectId = ref<string | null>(
    localStorage.getItem(STORAGE_KEY),
  );

  function setProject(id: string | null): void {
    selectedProjectId.value = id;
    if (id) localStorage.setItem(STORAGE_KEY, id);
    else localStorage.removeItem(STORAGE_KEY);
  }

  /**
   * Reconcile the stored choice against the tenant's projects (from /me):
   * keep it if still valid, otherwise default to the first project.
   */
  function syncWith(projects: ProjectInfo[]): void {
    if (!projects.length) {
      setProject(null);
      return;
    }
    const stillValid = projects.some((p) => p.id === selectedProjectId.value);
    if (!stillValid) setProject(projects[0].id);
  }

  return { selectedProjectId, setProject, syncWith };
});
